import { isAxiosError } from "axios"

export const handleAxiosError = (error: unknown) => {
  if (
    isAxiosError(error) &&
    error.response &&
    typeof error.response.data === "string"
  ) {
    throw new Error(error.response.data)
  } else {
    throw error
  }
}
